export default __webpack_public_path__ + "static/media/BOS.261c8f65.jpg";